import { FaFileAlt } from "react-icons/fa";
import { NavLink } from "react-router-dom";

function Sidebar() {
  return (
    <div
      className="bg-light border-end p-3"
      style={{ width: "220px", minHeight: "calc(100vh - 56px)" }} // Adjust for navbar
    >
      <ul className="nav flex-column gap-2">
        <li>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Dashboard</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/outgoing"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Outgoing</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/incoming"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Incoming</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/report"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Report</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/suppliers"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Suppliers</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/coaters"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Coaters</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/sites"
            className={({ isActive }) =>
              `btn w-100 text-start fw-bold d-flex align-items-center gap-2 ${
                isActive ? "btn-dark text-white" : "btn-outline-secondary"
              }`
            }
          >
            <FaFileAlt />
            <span>Sites</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
